import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoadingController, ModalController, Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '@services/api/api.service';
import { EndpointsService } from '@services/api/endpoints.service';
import { MedicosService } from '@services/users/medicos/medicos.service';
import { AlertService } from '@services/utils/alerts/alert.service';
import { ValidationService } from '@services/utils/validations/validation.service';
import { IonicSelectableComponent } from 'ionic-selectable';
import { first } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-update-profile',
  templateUrl: './update-profile.page.html',
  styleUrls: ['./update-profile.page.scss']
})
export class UpdateProfilePage implements OnInit {
  @Input() userData: any
  updateProfileForm: FormGroup
  submitted: boolean = false
  status_city: boolean = true
  userInfo: any
  specialties = []
  states = []
  cities = []
  isFirstTime = true

  specialty_name

  eyeImage: string = 'eye-off'
  typeInput: string = 'password'

  permissions = [false, false]
  validationId = 'onlyNumber'
  validationReqPrefix = true
  validationReq = true
  url = this.endpointsService.url

  constructor(
    private endpointsService: EndpointsService,
    private apiService: ApiService,
    private validationService: ValidationService,
    public medicosService: MedicosService,
    public loadingController: LoadingController,
    public modalController: ModalController,
    private alertService: AlertService,
    private platform: Platform,
    private router: Router,
    public formBuilder: FormBuilder,
    private storage: Storage,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.submitted = true
    this.validateForm()
    this.loadSpecialities()
    this.enableFields(this.userData.country_name)
    this.specialties = []

    this.storage.get(environment.localStorage).then((user) => {
      if (user != null) {
        this.loadStates(user.country_name)
        this.validateCountry()
      }
    })
  }

  validateCountry() {
    let country = ''
    switch (this.userData.country_name) {
      case 'Argentina':
        this.validationId = 'onlyNumber'
        this.validationReqPrefix = true
        country = 'es_Ar'
        break
      case 'Chile':
        this.validationId = 'onlyNumberGuion'
        this.validationReqPrefix = false
        country = 'es_Ch'
        break
      case 'Paraguay':
        this.validationId = 'onlyNumber'
        this.validationReqPrefix = false
        country = 'es_Pa'
        break
      default:
        console.log('No hay lenguaje: ' + this.userData.country_name)
    }
    this.translate.use(country)
    this.updateProfileForm.controls['prefix'].setValidators([
      this.validationService.Validation(0, 6, this.validationId, this.validationReqPrefix)
    ])
    this.updateProfileForm.controls['prefix'].updateValueAndValidity()
  }

  validateSpecialty(rol_id) {
    if (rol_id == 3 || rol_id == 7 || rol_id == 11) {
      this.updateProfileForm.controls['specialty_name'].setValidators([Validators.compose([Validators.required])])
      this.updateProfileForm.controls['specialty_name'].updateValueAndValidity()
    } else {
      this.updateProfileForm.controls['specialty_name'].clearValidators()
      this.updateProfileForm.controls['specialty_name'].updateValueAndValidity()
      this.updateProfileForm.controls['tuition'].clearValidators()
      this.updateProfileForm.controls['tuition'].updateValueAndValidity()
    }
  }

  // new changes

  enableFields(country_name) {
    let rol_id = this.userData.rol_id

    this.validateSpecialty(rol_id)

    switch (country_name) {
      case 'Argentina':
        if (rol_id == 3 || rol_id == 7 || rol_id == 11) {
          this.permissions = [true, true]
        } else {
          this.permissions = [false, false]
        }
        this.validationId = 'onlyNumber'
        this.validationReq = true
        break
      case 'Chile':
        if (rol_id == 3 || rol_id == 7 || rol_id == 11) {
          this.permissions = [true, true]
        } else {
          this.permissions = [false, false]
        }
        this.validationId = 'onlyNumberGuion'
        this.validationReq = false

        break
      case 'Paraguay':
        if (rol_id == 3 || rol_id == 7 || rol_id == 11) {
          this.permissions = [true, true]
        } else {
          this.permissions = [false, false]
        }
        this.validationId = 'onlyNumber'
        this.validationReq = true
        break
      default:
        console.log('No hay lenguaje: ' + country_name)
    }
  }

  showDetailsError() {
    this.updateProfileForm.markAllAsTouched()
    this.alertService.statusAlert('Error!', 'Faltan campos por llenar o la información no es valida.')
  }

  portChange(event: { component: IonicSelectableComponent; value: any }) {
    this.specialty_name = event
  }

  // end changes

  async closeModal() {
    await this.modalController.dismiss()
  }

  async updateProfile() {
    if (this.updateProfileForm.invalid) {
      this.showDetailsError()
      return false
    }

    let dataForm = this.updateProfileForm.controls
    let prefix_2 = dataForm.prefix_2.value
    if (dataForm.phone_number_2.value.length < 1) {
      prefix_2 = ''
    }

    this.userInfo = {
      id: this.userData.id,
      email: dataForm.email.value,
      password: dataForm.password.value,
      first_name: dataForm.first_name.value,
      last_name: dataForm.last_name.value,
      prefix: dataForm.prefix.value,
      phone_number: dataForm.phone_number.value,
      prefix_2: prefix_2,
      phone_number_2: dataForm.phone_number_2.value,
      specialty_name: dataForm.specialty_name.value.name,
      identification: dataForm.ced_user.value,
      tuition: dataForm.tuition.value,
      state_name: dataForm.state_name.value.name,
      city_name: dataForm.city_name.value.name,
      active: true
    }

    await this.alertService.presentLoading()

    this.medicosService
      .updateProfile(this.userInfo)
      .pipe(first())
      .subscribe(
        (res) => {
          this.storage.get(environment.localStorage).then((data) => {
            if (data != null) {
              let updateData = data

              updateData.id = this.userData.id
              updateData.first_name = dataForm.first_name.value
              updateData.last_name = dataForm.last_name.value
              updateData.email = dataForm.email.value
              updateData.prefix = dataForm.prefix.value
              updateData.phone_number = dataForm.phone_number.value
              updateData.prefix_2 = prefix_2
              updateData.phone_number_2 = dataForm.phone_number_2.value
              updateData.identification = dataForm.ced_user.value
              updateData.tuition = dataForm.tuition.value
              updateData.city_name = dataForm.city_name.value.name
              updateData.city_id = this.cities
                .filter((obj) => {
                  return obj.id == dataForm.city_name.value.id
                })
                .map((i) => {
                  return i.name
                })[0]

              updateData.state_name = dataForm.state_name.value.name
              updateData.state_id = this.states
                .filter((obj) => {
                  return obj.id == dataForm.state_name.value.id
                })
                .map((i) => {
                  return i.name
                })[0]

              updateData.specialty_name = dataForm.specialty_name.value.name
              updateData.active = true

              this.storage.set(environment.localStorage, updateData)
            }
          })
          this.success(res)
        },
        (err) => {
          this.error()
        }
      )
  }

  validateForm() {
    this.updateProfileForm = this.formBuilder.group({
      first_name: [this.userData.first_name, [this.validationService.Validation(3, 51, 'onlyLetter')]],
      last_name: [this.userData.last_name, [this.validationService.Validation(3, 51, 'onlyLetter')]],
      email: [this.userData.email, [this.validationService.Validation(6, 51, 'onlyEmail')]],
      prefix: [this.userData.prefix, [this.validationService.Validation(0, 7, 'onlyNumber', false)]],
      phone_number: [this.userData.phone_number, [this.validationService.Validation(3, 16, 'onlyNumber')]],
      prefix_2: [this.userData.prefix_2, [this.validationService.Validation(0, 7, 'onlyNumber', false)]],
      phone_number_2: [this.userData.phone_number_2, [this.validationService.Validation(3, 16, 'onlyNumber', false)]],
      ced_user: [this.userData.identification, [this.validationService.Validation(3, 51, 'anyText')]],
      tuition: [this.userData.tuition, [this.validationService.Validation(3, 51, 'anyText')]],
      specialty_name: ['', Validators.compose([Validators.required])],
      state_name: ['', Validators.compose([Validators.required])],
      city_name: ['', Validators.compose([Validators.required])],
      password: ['', [this.validationService.Validation(3, 51, 'onlyPassword')]]
    })
  }

  loadSpecialities() {
    this.apiService
      .getAll(this.url.specialty)
      .pipe(first())
      .subscribe(
        (res) => {
          const filterSpecialities = res.filter( s => s.name != 'No suministrado')
          this.specialties = filterSpecialities

          let pos = this.specialties.findIndex((e) => {
            return e.name == this.userData.specialty_name
          })

          if (pos >= 0) this.updateProfileForm.controls['specialty_name'].setValue(this.specialties[pos])
        },
        (err) => {}
      )
  }

  loadStates(country_name) {
    this.states = []
    this.apiService
      .getAll(this.url.state)
      .pipe(first())
      .subscribe(
        (res) => {
          // Filtrar solo estados activos del país
          this.states = res.filter((obj) => {
            return obj.active && obj.country_name == country_name
          })

          // Buscar el estado del usuario en todos los resultados
          let existingState = res.find((obj) => 
            obj.country_name == country_name && 
            obj.name === this.userData.state_name
          )

          // Si existe pero no está activo, agregarlo a la lista
          if (existingState && !existingState.active) {
            this.states.push(existingState)
          }

          // Si no existe en absoluto, crear uno temporal
          if (!existingState && this.userData.state_name) {
            existingState = {
              id: `temp_${this.userData.state_name}`,
              name: this.userData.state_name,
              country_name: country_name,
              active: false
            }
            this.states.push(existingState)
          }

          // Preseleccionar el estado
          if (existingState) {
            this.updateProfileForm.controls['state_name'].setValue(existingState)
          }

          this.loadCities()
        },
        (err) => {}
      )
  }

  onStateChange() {
    // Marcar que ya no es la primera vez para no agregar ciudades temporales
    this.isFirstTime = false
    // Limpiar la ciudad seleccionada
    this.updateProfileForm.controls['city_name'].setValue(null)
    this.loadCities()
  }

  loadCities() {
    let data = this.updateProfileForm.controls
    if (data.state_name.value && data.state_name.value.id) {
      let state = data.state_name.value.id
      
      // Si el estado es temporal (string), no cargar ciudades del API
      if (typeof state === 'string' && state.startsWith('temp_')) {
        this.cities = []
        // Solo crear ciudad temporal en la primera carga
        if (this.isFirstTime && this.userData.city_name) {
          const tempCity = {
            id: `temp_${this.userData.city_name}`,
            name: this.userData.city_name,
            state_id: state,
            states_name: this.userData.state_name,
            code: this.userData.prefix || '',
            active: false
          }
          this.cities.push(tempCity)
          this.updateProfileForm.controls['city_name'].setValue(tempCity)
        }
        this.status_city = false
        this.isFirstTime = false
        return
      }
      
      this.apiService
        .getAll(this.url.city)
        .pipe(first())
        .subscribe(
          (res) => {
            // Filtrar solo ciudades activas del estado
            this.cities = res.filter((obj) => {
              return obj.active && obj.state_id == state
            })

            let selectedCity = null

            // Solo buscar y agregar ciudades inactivas/temporales en la primera carga
            if (this.isFirstTime) {
              // Buscar la ciudad del usuario en todos los resultados
              selectedCity = res.find((obj) => 
                obj.state_id == state && 
                obj.name === this.userData.city_name && 
                obj.states_name === this.userData.state_name
              )

              // Si existe pero no está activa, agregarla a la lista
              if (selectedCity && !selectedCity.active) {
                this.cities.push(selectedCity)
              }

              // Si no existe en absoluto, crear una temporal
              if (!selectedCity && this.userData.city_name) {
                selectedCity = {
                  id: `temp_${this.userData.city_name}`,
                  name: this.userData.city_name,
                  state_id: state,
                  states_name: this.userData.state_name,
                  code: this.userData.prefix || '',
                  active: false
                }
                this.cities.push(selectedCity)
              }

              // Preseleccionar la ciudad
              if (selectedCity) {
                this.updateProfileForm.controls['city_name'].setValue(selectedCity)
              }

              this.isFirstTime = false
            }

            this.status_city = false
          },
          (err) => {}
        )
    }
  }

  loadPrefix() {
    let data = this.updateProfileForm.controls
    let city = data.city_name.value.code
    this.updateProfileForm.controls['prefix'].setValue(city)
    this.updateProfileForm.controls['prefix_2'].setValue(city)
  }

  success(res) {
    this.alertService.dismiss().then(() => {
      if (res.error) {
        this.alertService.statusAlert('Error!', 'La información no se pudo actualizar')
      } else {
        this.alertService.statusAlert('Información actualizada!', 'La Información ha sido cambiada exitosamente')

        if (this.platform.is('cordova') || this.platform.is('capacitor')) this.updateEmailBiometric()
        this.modalController.dismiss()
        //IR A MENU
      }
    })
  }

  error() {
    this.alertService.dismiss().then(() => {
      this.alertService.statusAlert('Error!', 'La información no se pudo actualizar')
    })
  }

  get errorControl() {
    return this.updateProfileForm.controls
  }

  updateEmailBiometric() {
    let dataForm = this.updateProfileForm.controls
    let data
    this.storage.get(environment.storageBiometric).then((val) => {
      if (val != null) {
        data = val
        data.email = dataForm.email.value
        this.storage?.set(environment.storageBiometric, data)
      }
    })
  }

  changeImage() {
    if (this.eyeImage == 'eye-off') {
      this.eyeImage = 'eye'
      this.typeInput = 'text'
      setTimeout(() => {
        this.eyeImage = 'eye-off'
        this.typeInput = 'password'
      }, 2000)
    } else {
      this.eyeImage = 'eye-off'
      this.typeInput = 'password'
    }
  }
}
